<template>
  <nav class="navbar column" role="navigation" aria-label="main navigation">
    <div class="container">
      <div :class="menuClass">
        <div class="mobile-menu">
          <router-link :to="{ name: 'home' }">
            <div class="span-holder">
              <span>האימון שלי</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="33"
              style="overflow: visible"
            >
              <!-- eslint-disable-next-line max-len -->
              <path
                class="st0"
                d="m30.237 9.582c-0.437 0-0.866 0.023-1.289 0.072-0.423 0.048-0.839 0.119-1.247 0.211l0.705-0.705 0.703-0.703c0.737-0.738 1.104-1.708 1.104-2.676 0-0.969-0.368-1.938-1.105-2.673-0.581-0.581-1.313-0.942-2.082-1.064-0.769-0.123-1.575-7e-3 -2.308 0.365-0.174 0.088-0.343 0.19-0.504 0.309-0.16 0.116-0.313 0.247-0.457 0.391l-3.517 3.517-3.519 3.519v-8.868c0-0.975-0.396-1.86-1.038-2.502-0.641-0.641-1.526-1.037-2.502-1.037-0.473 0-0.932 0.092-1.356 0.268-0.423 0.176-0.813 0.436-1.147 0.77s-0.593 0.724-0.769 1.146c-0.175 0.425-0.267 0.882-0.267 1.355v15.952l-3.219 3.219-3.22 3.223c-0.32-1.723-1.237-3.24-2.528-4.324-1.29-1.086-2.954-1.74-4.769-1.74-2.047 0-3.903 0.832-5.247 2.178-1.344 1.344-2.176 3.199-2.176 5.246s0.833 3.902 2.176 5.246c1.344 1.346 3.2 2.178 5.247 2.178 0.735 0 1.461-0.111 2.156-0.322 0.694-0.209 1.356-0.521 1.962-0.928 0.317 0.395 0.713 0.707 1.163 0.92 0.45 0.215 0.954 0.33 1.486 0.33h16.043c0.46 0 0.906-0.09 1.319-0.262 0.413-0.17 0.792-0.422 1.118-0.748 0.313-0.314 0.559-0.678 0.729-1.072 0.172-0.396 0.266-0.824 0.278-1.266 1.035 1.033 2.267 1.871 3.634 2.449 1.366 0.578 2.867 0.898 4.442 0.898 3.152 0 6.011-1.283 8.082-3.354 2.07-2.07 3.353-4.93 3.353-8.082s-1.282-6.012-3.353-8.083c-2.07-2.07-4.928-3.353-8.081-3.353zm-19.181-8.305c0-0.283 0.056-0.559 0.161-0.813 0.106-0.255 0.262-0.488 0.462-0.689 0.201-0.2 0.435-0.356 0.689-0.462 0.255-0.104 0.53-0.159 0.813-0.159 0.587 0 1.118 0.237 1.502 0.621 0.385 0.386 0.624 0.917 0.624 1.502v10.284l-2.125 2.127-2.125 2.125v-14.536zm-21.159 23.752c0-1.656 0.674-3.158 1.762-4.248 1.088-1.088 2.59-1.762 4.247-1.762 1.645 0 3.137 0.666 4.223 1.74s1.765 2.559 1.785 4.199l-0.829 0.828-0.828 0.828c-0.447 0.447-0.75 0.98-0.9 1.549-0.15 0.572-0.146 1.178 0.019 1.77-0.504 0.359-1.06 0.635-1.646 0.82-0.585 0.188-1.201 0.285-1.824 0.285-1.657 0-3.159-0.674-4.247-1.762-1.087-1.087-1.762-2.588-1.762-4.247zm30.257 5.414c-0.193 0.191-0.416 0.34-0.66 0.441-0.243 0.102-0.506 0.154-0.777 0.154h-16.044c-0.494 0-0.895-0.16-1.203-0.395-0.309-0.236-0.525-0.545-0.649-0.846-0.123-0.297-0.189-0.67-0.137-1.053 0.053-0.385 0.224-0.781 0.572-1.129l11.75-11.754 11.75-11.754c0.092-0.09 0.188-0.172 0.288-0.246 0.101-0.072 0.206-0.138 0.315-0.193 0.459-0.232 0.963-0.305 1.445-0.228 0.481 0.076 0.939 0.303 1.303 0.666 0.462 0.461 0.692 1.067 0.693 1.673 0 0.607-0.23 1.214-0.691 1.676l-1.88 1.881-1.878 1.879c-1.627 0.98-2.99 2.354-3.959 3.987-0.969 1.634-1.542 3.529-1.588 5.552-2e-3 0.041-0.011 0.172-0.023 0.297-0.012 0.127-0.027 0.254-0.037 0.291-0.102 0.357-0.241 0.699-0.418 1.023-0.178 0.324-0.391 0.629-0.637 0.908l-1.012 1.141-1.012 1.145h-8.002c-0.196 0-0.373 0.08-0.501 0.207-0.127 0.127-0.207 0.305-0.207 0.5s0.079 0.373 0.207 0.5c0.128 0.129 0.305 0.207 0.501 0.207h10.992c0.567 0 1.086 0.225 1.465 0.586 0.38 0.361 0.619 0.859 0.629 1.408 5e-3 0.279-0.046 0.551-0.146 0.799-0.103 0.252-0.253 0.482-0.449 0.677zm-0.321-4.681c-0.185-0.064-0.376-0.115-0.573-0.148-0.197-0.035-0.398-0.053-0.605-0.053h-1.098l0.596-0.674 0.597-0.674c0.067-0.076 0.134-0.154 0.196-0.234 0.063-0.078 0.125-0.16 0.184-0.24 0.086 0.35 0.189 0.695 0.307 1.033s0.249 0.667 0.396 0.99zm10.404 5.277c-2.763 0-5.269-1.125-7.083-2.939s-2.938-4.318-2.938-7.082 1.124-5.268 2.938-7.083 4.32-2.938 7.083-2.938 5.268 1.123 7.082 2.938c1.814 1.814 2.938 4.319 2.938 7.083s-1.124 5.268-2.938 7.082-4.319 2.939-7.082 2.939z"
              />
            </svg>
          </router-link>

          <router-link :to="{ name: 'allseries' }">
            <div class="span-holder">
              <span>סדרות ותוכניות</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="43.497"
              height="31.064"
            >
              <g class="st0">
                <path
                  d="M12.084 8.95l-1.053-.122c.46-3.945 1.584-6.428 1.631-6.53l.244-.532.506.295c.096.058 2.364 1.4 4.756 4.002l-.781.716a23.448 23.448 0 0 0-3.99-3.466c-.348.929-.998 2.938-1.313 5.637zM30.33 9.219a31.612 31.612 0 0 0-1.295-5.88c-.777.55-2.295 1.724-3.935 3.571l-.793-.705c2.48-2.787 4.643-4.088 4.731-4.143l.54-.32.227.586c.045.115 1.11 2.903 1.58 6.763l-1.055.128zM17.458 31.064c-2.751 0-6.459-.565-9.669-3.001C1.965 23.643.172 14.855.098 14.484L0 13.989l.49-.122c.096-.024 2.364-.575 5.389-.365l-.072 1.057c-2.039-.141-3.74.09-4.551.234.475 1.935 2.453 8.843 7.174 12.426 5.469 4.147 12.744 2.41 12.818 2.393l.254 1.029c-.143.036-1.768.423-4.044.423z"
                />
                <path
                  d="M25.918 31.006c-2.518.002-4.361-.431-4.52-.471l.248-1.029c.079.019 7.96 1.854 13.42-2.287 4.724-3.583 6.698-10.489 7.175-12.425a19.179 19.179 0 0 0-5.392-.157l-.124-1.053c3.452-.403 6.167.254 6.28.283l.491.122-.096.495c-.074.371-1.867 9.159-7.693 13.579-3.131 2.375-6.904 2.943-9.789 2.943zM20.652 30.402c-.334-.059-8.2-1.521-12.392-8.08C4.095 15.804 4.963 6.835 5.002 6.457l.06-.566.562.099c.264.048 6.525 1.21 10.834 6.339l-.813.682c-3.32-3.952-8.008-5.434-9.631-5.845-.114 2.106-.229 9.317 3.14 14.585 3.943 6.171 11.605 7.593 11.684 7.606l-.186 1.045z"
                />
                <path
                  d="M22.381 30.35l-.186-1.043c.073-.014 7.434-1.396 11.369-7.556 3.367-5.268 3.255-12.479 3.139-14.586-1.683.429-6.671 2.009-10.008 6.313l-.839-.649c4.303-5.552 10.958-6.788 11.239-6.839l.563-.099.059.566c.037.378.908 9.347-3.258 15.865-4.191 6.559-11.759 7.971-12.078 8.028z"
                />
                <path
                  d="M21.389 30.697l-.412-.468c-.228-.259-5.592-6.441-5.711-14.631-.117-8.183 5.05-14.811 5.27-15.091L20.937 0l.419.496c.229.268 5.587 6.684 5.705 14.868.117 8.188-5.056 14.584-5.276 14.853l-.396.48zm-.422-28.979c-1.21 1.739-4.734 7.372-4.641 13.867.094 6.503 3.779 11.812 5.034 13.433 1.204-1.67 4.733-7.14 4.64-13.639-.093-6.497-3.773-11.972-5.033-13.661z"
                />
              </g>
            </svg>
          </router-link>

          <router-link :to="{ name: 'savedItems' }">
            <div class="span-holder">
              <span>שמורים</span>
            </div>
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              width="43.5"
              height="37.27"
            >
              <path
                class="st2"
                d="M21.75 36.29l-3-2.56C7.89 24.69.75 18.72.75 11.4.75 5.4 5.83.75 12.3.75a13 13 0 019.45 4 13 13 0 019.45-4c6.47 0 11.55 4.69 11.55 10.65 0 7.32-7.14 13.29-17.95 22.35z"
                fill="none"
                stroke-width="1.5"
              />
            </svg>
          </router-link>

          <router-link :to="{ name: 'history' }">
            <div class="span-holder">
              <span>היסטוריית צפייה</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="39"
              height="39"
              viewBox="0 0 38.9 38.9"
            >
              <!-- eslint-disable-next-line max-len -->
              <path
                class="st0"
                d="M19.4 0C8.7 0 0 8.7 0 19.4c0 10.7 8.7 19.4 19.4 19.4s19.4-8.7 19.4-19.4C38.9 8.7 30.2 0 19.4 0zM19.4 37.4c-9.9 0-18-8.1-18-18 0-9.9 8.1-18 18-18 9.9 0 18 8.1 18 18C37.4 29.4 29.4 37.4 19.4 37.4z"
              />
              <!-- eslint-disable-next-line max-len -->
              <path
                class="st0"
                d="M20.2 15.9V4.3c0-0.4-0.3-0.7-0.7-0.7 -0.4 0-0.7 0.3-0.7 0.7V15.9c-1.4 0.3-2.5 1.4-2.8 2.8H9.4c-0.4 0-0.7 0.3-0.7 0.7 0 0.4 0.3 0.7 0.7 0.7h6.6c0.3 1.6 1.8 2.9 3.5 2.9 2 0 3.6-1.6 3.6-3.6C23 17.7 21.8 16.2 20.2 15.9zM19.4 21.6c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2C21.6 20.6 20.6 21.6 19.4 21.6z"
              />
            </svg>
          </router-link>

          <router-link :to="{ name: 'teachers' }">
            <div class="span-holder">
              <span>המורים שלנו</span>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="42">
              <g class="st0">
                <!-- eslint-disable-next-line max-len -->
                <path
                  d="m19.901 18.594c-0.2-0.103-0.422-0.115-0.621-0.052-0.198 0.063-0.372 0.203-0.475 0.402l-9e-3 0.016-9e-3 0.017c-0.104 0.199-0.116 0.422-0.054 0.62 0.063 0.199 0.201 0.373 0.4 0.477 0.06 0.031 0.122 0.055 0.185 0.07s0.127 0.022 0.19 0.022c0.147 0 0.291-0.04 0.417-0.114 0.125-0.076 0.233-0.185 0.306-0.324l0.01-0.02 9e-3 -0.018c0.104-0.201 0.115-0.424 0.053-0.621-0.063-0.199-0.202-0.373-0.402-0.475z"
                />
                <!-- eslint-disable-next-line max-len -->
                <path
                  d="m28.8 32.858h-0.092v-10.911c0-0.912-0.253-1.778-0.709-2.519-0.457-0.742-1.117-1.357-1.932-1.767l-2.355-1.185-2.354-1.186c-0.5-0.252-0.911-0.621-1.21-1.064-0.297-0.443-0.48-0.962-0.524-1.514 0.823-0.537 1.508-1.271 1.987-2.133 0.479-0.863 0.752-1.855 0.752-2.91v-2.313c0-1.66-0.676-3.166-1.766-4.256-1.091-1.09-2.596-1.766-4.256-1.766s-3.165 0.676-4.256 1.766c-1.09 1.09-1.765 2.596-1.765 4.256v2.314c0 1.055 0.273 2.047 0.751 2.91 0.479 0.861 1.164 1.596 1.986 2.133-0.043 0.552-0.227 1.07-0.524 1.514s-0.709 0.813-1.209 1.064l-2.354 1.186-2.355 1.185c-0.814 0.409-1.475 1.024-1.931 1.767-0.457 0.74-0.71 1.606-0.71 2.519v10.911c-1.121 0-2.139 0.457-2.875 1.194-0.737 0.737-1.193 1.755-1.193 2.876 0 1.123 0.457 2.141 1.194 2.877 0.736 0.738 1.754 1.194 2.876 1.194h24.824c1.123 0 2.141-0.456 2.877-1.194 0.738-0.736 1.194-1.754 1.194-2.877 0-1.122-0.456-2.14-1.194-2.877-0.737-0.738-1.754-1.194-2.877-1.194zm-16.853-25.187v-2.315c0-1.211 0.493-2.311 1.289-3.105 0.796-0.796 1.894-1.288 3.105-1.288s2.31 0.492 3.105 1.288c0.795 0.795 1.288 1.895 1.288 3.105v2.314c0 1.211-0.493 2.31-1.288 3.105-0.796 0.795-1.895 1.288-3.105 1.288-1.211 0-2.31-0.493-3.105-1.288-0.796-0.795-1.289-1.893-1.289-3.104zm-6.346 14.276c0-0.603 0.167-1.175 0.469-1.665 0.301-0.489 0.738-0.896 1.276-1.166l2.355-1.186 2.355-1.186c0.666-0.334 1.229-0.808 1.662-1.374 0.433-0.567 0.735-1.228 0.881-1.938 0.276 0.083 0.56 0.148 0.851 0.191 0.291 0.044 0.589 0.067 0.892 0.067s0.601-0.023 0.891-0.067c0.291-0.043 0.576-0.108 0.851-0.191 0.146 0.71 0.449 1.37 0.881 1.938 0.433 0.566 0.996 1.04 1.662 1.374l2.355 1.186 2.354 1.186c0.538 0.27 0.974 0.677 1.276 1.166 0.301 0.49 0.469 1.063 0.469 1.665v10.911h-17.331v-5.476c1.684-0.447 3.269-1.137 4.714-2.049s2.752-2.045 3.881-3.375c0.146-0.172 0.207-0.386 0.19-0.594-0.017-0.207-0.112-0.408-0.284-0.554-0.171-0.146-0.385-0.208-0.592-0.19-0.209 0.017-0.41 0.113-0.555 0.284-0.975 1.147-2.095 2.133-3.331 2.938-1.236 0.804-2.587 1.427-4.024 1.851v-0.816c0-0.225-0.091-0.429-0.239-0.576-0.146-0.146-0.35-0.238-0.575-0.238s-0.428 0.092-0.575 0.238c-0.147 0.147-0.239 0.352-0.239 0.576v7.982h-2.52v-10.912zm9.863 17.42s-0.414 1e-3 -0.831 1e-3c-0.418 2e-3 -0.839 3e-3 -0.854 4e-3h-9.803c-0.674 0-1.285-0.273-1.728-0.716-0.442-0.442-0.716-1.054-0.716-1.728s0.274-1.285 0.716-1.727c0.443-0.443 1.054-0.717 1.728-0.717h18.8c-0.362 0.271-0.704 0.575-1.02 0.907-0.315 0.331-0.605 0.692-0.866 1.081-0.607 0.905-1.419 1.629-2.351 2.126s-1.984 0.769-3.075 0.769zm13.336 5e-3h-8.45c0.363-0.271 0.707-0.576 1.023-0.908 0.316-0.333 0.607-0.695 0.869-1.084 0.607-0.906 1.419-1.631 2.35-2.127 0.933-0.498 1.985-0.768 3.077-0.768h1.131c0.674 0 1.284 0.273 1.727 0.717 0.443 0.441 0.717 1.053 0.717 1.727s-0.273 1.285-0.716 1.728-1.054 0.715-1.728 0.715z"
                />
              </g>
            </svg>
          </router-link>

          <router-link :to="{ name: 'account' }">
            <div class="span-holder">
              <span>ניהול חשבון</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="43"
              height="43"
              viewBox="0 0 42.7 43.1"
            >
              <!-- eslint-disable-next-line max-len -->
              <path
                class="st0"
                d="M23 43.1h-3.4c-0.7 0-1.2-0.6-1.3-1.1l-1.3-4.8c0 0-0.1-0.1-0.2-0.2l-3.1-1.3c-0.1 0-0.3 0-0.3 0l-4.3 2.5c-0.5 0.3-1.2 0.2-1.7-0.2 0 0-0.7-0.6-1.3-1.2 -0.6-0.6-1.2-1.3-1.2-1.3 -0.4-0.5-0.4-1.2-0.2-1.7l2.5-4.3c0 0 0-0.2 0-0.2l-1.3-3.1c0-0.1-0.1-0.2-0.2-0.2l-4.8-1.3C0.5 24.5 0 23.9 0 23.3L0 19.9c0-0.6 0.5-1.2 1.1-1.4l4.8-1.3c0.1 0 0.2-0.1 0.2-0.2l1.3-3.1c0-0.1 0-0.2 0-0.3L4.9 9.4c-0.3-0.5-0.2-1.2 0.2-1.7 0 0 0.6-0.8 1.2-1.3C6.8 5.9 7.5 5.3 7.5 5.3 8 4.9 8.7 4.8 9.2 5.1l4.3 2.5c0 0 0.2 0 0.2 0l3.1-1.3c0.1 0 0.2-0.2 0.2-0.2l1.3-4.9C18.5 0.7 19 0 19.7 0h3.4c0.7 0 1.2 0.7 1.4 1.2l1.3 5c0 0 0.1 0.2 0.2 0.2l3.1 1.3c0.1 0.1 0.3 0 0.3 0l4.3-2.5c0.5-0.3 1.2-0.2 1.7 0.2 0 0 0.8 0.6 1.3 1.2 0.5 0.5 1.2 1.3 1.2 1.3 0.4 0.5 0.4 1.2 0.2 1.7l-2.5 4.3c0 0 0 0.2 0 0.2l1.3 3c0 0.1 0.1 0.2 0.2 0.2l4.8 1.3c0.6 0.2 1 0.7 1.1 1.3l0 3.4c0 0.6-0.5 1.2-1.1 1.4l-4.8 1.3c-0.1 0-0.2 0.1-0.2 0.2l-1.3 3.1c0 0.1 0 0.2 0 0.3l2.5 4.3c0.3 0.5 0.2 1.2-0.2 1.7 0 0-0.6 0.8-1.2 1.3 -0.6 0.6-1.3 1.2-1.3 1.2 -0.4 0.4-1.2 0.4-1.7 0.1l-4.3-2.5c0 0-0.2 0-0.2 0l-3.1 1.3c-0.1 0-0.2 0.1-0.2 0.2l-1.3 4.8C24.2 42.5 23.7 43.1 23 43.1zM19.7 41.7h3.3c0 0 0 0 0-0.1l1.3-4.8c0.1-0.5 0.6-1 1.1-1.2l3-1.2c0.2-0.1 0.5-0.1 0.7-0.1 0.3 0 0.6 0.1 0.8 0.2l4.3 2.5c0 0 0.7-0.6 1.3-1.1 0.5-0.5 1.1-1.2 1.1-1.2l-2.5-4.4c-0.3-0.5-0.3-1.1 0-1.6l1.2-3c0.2-0.5 0.6-0.9 1.1-1l4.8-1.3 0-3.4 -4.8-1.3c-0.5-0.1-1-0.6-1.2-1.1l-1.2-3c-0.2-0.4-0.2-1.1 0.1-1.5l2.5-4.3c0 0-0.6-0.7-1.1-1.2 -0.5-0.5-1.2-1.1-1.2-1.1l-4.4 2.5c-0.2 0.1-0.5 0.2-0.8 0.2 -0.2 0-0.5 0-0.8-0.2l-3-1.2c-0.4-0.1-0.9-0.6-1-1.1l-1.3-5c0 0 0-0.1-0.1-0.1h-3.2c0 0-0.1 0.1-0.1 0.1l-1.3 4.9c-0.1 0.5-0.6 1-1.1 1.2l-3 1.2c-0.2 0.1-0.5 0.1-0.7 0.1 -0.3 0-0.6-0.1-0.8-0.2L8.5 6.4c0 0-0.7 0.6-1.2 1.1C6.7 8 6.1 8.7 6.1 8.7h0c0 0 0 0 0 0.1l2.4 4.3c0.3 0.5 0.3 1.1 0 1.6l-1.2 3c-0.1 0.5-0.6 0.9-1.2 1l-4.8 1.3L1.4 23.3l4.8 1.3c0.5 0.1 1 0.6 1.2 1.1l1.2 3c0.2 0.4 0.2 1.1-0.1 1.5l-2.5 4.3c0 0 0.6 0.7 1.1 1.3 0.5 0.5 1.2 1.1 1.2 1.1l4.4-2.5c0.5-0.3 1.1-0.3 1.6 0l3 1.2c0.4 0.2 0.9 0.6 1 1.1l1.3 4.9C19.7 41.6 19.7 41.7 19.7 41.7zM21.4 29.1c-2 0-3.9-0.8-5.3-2.2 -1.4-1.4-2.2-3.3-2.2-5.3 0-2 0.8-3.8 2.2-5.2 1.4-1.4 3.3-2.2 5.2-2.2 2 0 3.9 0.8 5.3 2.2 1.4 1.4 2.2 3.3 2.2 5.2 0 2-0.8 3.8-2.2 5.2C25.2 28.3 23.3 29.1 21.4 29.1zM21.4 15.7c-1.6 0-3.1 0.6-4.2 1.7 -1.1 1.1-1.8 2.6-1.8 4.2 0 1.6 0.6 3.1 1.7 4.2 1.1 1.1 2.6 1.8 4.2 1.8 1.6 0 3.1-0.6 4.2-1.7 1.1-1.1 1.8-2.6 1.8-4.2 0-1.6-0.6-3.1-1.7-4.2C24.5 16.3 23 15.7 21.4 15.7z"
              />
            </svg>
          </router-link>

          <router-link :to="{ name: 'profile' }">
            <div class="span-holder">
              <span>עריכת פרופיל</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="39"
              height="39"
              viewBox="0 0 38.9 38.9"
            >
              <!-- eslint-disable-next-line max-len -->
              <path
                class="st0"
                d="M28.8 17.3c-0.4 0-0.7 0.3-0.7 0.7v18.7c0 0.4-0.3 0.7-0.7 0.7H2.2c-0.4 0-0.7-0.3-0.7-0.7v-25.9h7.2c1.2 0 2.2-1 2.2-2.2V1.4h16.6c0.4 0 0.7 0.3 0.7 0.7V3.6c0 0.4 0.3 0.7 0.7 0.7s0.7-0.3 0.7-0.7V2.2c0-1.2-1-2.2-2.2-2.2h-16.6C9.8 0 8.5 0.5 7.8 1.2L1.2 7.8C0.5 8.5 0 9.8 0 10.8v25.9c0 1.2 1 2.2 2.2 2.2H27.4c1.2 0 2.2-1 2.2-2.2V18C29.5 17.6 29.2 17.3 28.8 17.3zM8.9 2.2C9 2.1 9.2 2 9.4 1.9v6.8c0 0.4-0.3 0.7-0.7 0.7H1.9C2 9.2 2.1 9 2.2 8.9L8.9 2.2z"
              />
              <!-- eslint-disable-next-line max-len -->
              <path
                class="st0"
                d="M31.5 5.3c-0.3-0.3-0.7-0.3-1 0l-15.8 15.1c-0.1 0.1-0.1 0.2-0.2 0.3l-2.2 5.8c-0.1 0.3 0 0.6 0.2 0.8 0.1 0.1 0.3 0.2 0.5 0.2 0.1 0 0.2 0 0.3-0.1l5.8-2.9c0.1 0 0.1-0.1 0.2-0.1L34.4 9.1c0.3-0.3 0.3-0.7 0-1L31.5 5.3zM18.3 23.2l-4 2 1.5-3.9 15.2-14.5 1.9 1.9L18.3 23.2z"
              />
              <!-- eslint-disable-next-line max-len -->
              <path
                class="st0"
                d="M35.3 0.7h-0.3L32.1 3.6 36 7.5l2.9-2.9V4.3C38.9 1.5 36.5 0.7 35.3 0.7zM36 5.5L34.1 3.6l1.4-1.4c0.6 0.1 1.7 0.4 1.9 1.9L36 5.5z"
              />
            </svg>
          </router-link>

          <router-link :to="{ name: 'preferences' }">
            <div class="span-holder">
              <span>העדפות</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="38"
              height="42"
              viewBox="0 0 37.7 41.8"
            >
              <!-- eslint-disable-next-line max-len -->
              <path
                class="st0"
                d="M34.2 41.8H3.5C1.5 41.8 0 40.3 0 38.4c0-0.1 0.1-1.5 0.7-3.6 0.7-2.6 6.3-4.5 11.7-6.1l0.7-0.2c0.5-0.1 1-1.6 1.1-3.7 -0.6-0.5-1.1-1.1-1.6-1.9 -0.1-0.2-0.3-0.5-0.4-0.7 -0.5-0.8-1-1.5-1.4-2.6 -0.5-0.2-0.9-0.5-1.1-1 -0.9-1.6-1.4-4.2-1-5.2 0.2-0.4 0.5-0.8 1-0.9 0-3.8 1.3-6.2 2.6-7.7 0-0.1 0-0.3 0-0.4 0.4-1.3 1.6-1.9 2.8-2 0-0.2 0.1-0.5 0.2-0.7 0.2-0.6 0.8-1.4 1.4-1.6 0.2 0 0.4 0 0.5 0.1 0.2 0.1 0.3 0.3 0.3 0.5 0 0.1 0.5 0.4 1.1 0.6 1.7 0.5 2.9 0.9 3.6 1.3 3.6 1.4 5.8 5.2 5.8 10 0.4 0.2 0.7 0.5 0.9 0.9 0.4 1-0.1 3.6-1 5.3 -0.2 0.4-0.6 0.8-1 1 -0.4 1-0.9 1.8-1.4 2.6 -0.1 0.2-0.3 0.5-0.4 0.7 -0.5 0.8-0.9 1.3-1.4 1.8 0.1 2 0.5 3.6 1.1 3.8 1 0.4 2.2 0.8 3.5 1.2 4 1.2 8.1 2.5 8.8 5.1 0.6 2.2 0.7 2.9 0.7 3.6C37.7 40.3 36.1 41.8 34.2 41.8zM10.3 13.7c-0.2 0-0.3 0.1-0.3 0.1 -0.2 0.5 0.2 2.6 0.9 4.1 0.1 0.2 0.3 0.4 0.4 0.4 0.3 0 0.6 0.2 0.7 0.5 0.4 1.1 0.8 1.8 1.4 2.6 0.1 0.2 0.3 0.5 0.4 0.7 0.5 0.8 1 1.3 1.5 1.7 0.2 0.1 0.3 0.4 0.3 0.6 0 1.4-0.3 4.9-2.1 5.4l-0.7 0.2c-6.7 2-10.3 3.7-10.7 5.1 -0.5 2-0.6 3.3-0.6 3.3 0 1.1 0.9 2 2 2h30.8c1.1 0 2-0.9 2-2 0-0.6-0.1-1.1-0.6-3.3 -0.5-1.8-4.5-3.1-7.8-4.1 -1.3-0.4-2.6-0.8-3.7-1.2 -1.7-0.7-2-3.7-2-5.5 0-0.2 0.1-0.4 0.3-0.6 0.4-0.3 0.9-0.9 1.3-1.6 0.2-0.3 0.3-0.5 0.5-0.7 0.5-0.8 1-1.6 1.4-2.6 0.1-0.2 0.3-0.4 0.6-0.5 0.1 0 0.3-0.1 0.4-0.4 0.8-1.5 1.1-3.6 0.9-4.1 0 0-0.1 0-0.2 0 -0.2 0-0.4-0.1-0.5-0.2s-0.2-0.3-0.2-0.5c0.2-4.6-1.6-7.9-4.9-9.2 -0.7-0.3-1.8-0.8-3.4-1.2 -0.5-0.1-1.1-0.4-1.6-0.8 -0.1 0.2-0.2 0.4-0.2 0.5 0 0.1 0 0.2 0 0.2 0.2 0.2 0.2 0.6 0 0.8 -0.1 0.2-0.4 0.3-0.6 0.3h-0.1c-0.1 0-1.1 0-1.7 0.4 0 0 0 0.1 0 0.1 0.1 0.3 0.1 0.6-0.2 0.8 -1.4 1.2-3 3.6-2.8 8 0 0.2-0.1 0.4-0.2 0.5 -0.1 0.1-0.3 0.2-0.5 0.2H10.3z"
              />
            </svg>
          </router-link>
        </div>
      </div>
    </div>

    <div class="logo">
      <router-link class="yoga-logo" :to="{ name: 'home' }">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="127"
          height="67"
          viewBox="0 0 126.8 66.5"
        >
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st1"
            d="M76.7 34.3c-3.3-0.7-5.9-2.5-8.1-4.8 -2.3-2.3-3.7-5.1-4.9-8.4 -0.2 0.6-0.4 0.9-0.5 1.3 -1.6 4.1-4.1 7.5-7.8 9.9 -1.2 0.8-2.6 1.5-4.1 1.8 -0.2 0.1-0.4 0.1-0.7 0.1 -0.3-0.6 0.1-0.7 0.4-1 1.1-0.7 2.1-1.3 3.2-2 4.7-3.4 7.2-8.2 8.3-13.7 0.2-0.9 0-1.9 0-2.8 0-0.9 0.1-1.8 0.1-2.7 0-0.6 0-1.2 0-2 0.6-0.5 1.3-0.5 2 0 0 2.3 0 4.5 0 6.8 0 0.6 0.2 1.2 0.3 1.8 1.6 6.3 5 11.1 10.7 14.3C76.2 33.2 76.9 33.3 76.7 34.3z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M63.7 20.6c-5 0-9-4-9-9 0-5 4-9 9-9 5 0 9 4 9 9C72.7 16.6 68.6 20.6 63.7 20.6zM63.7 4C59.4 4 56 7.4 56 11.6c0 4.2 3.4 7.7 7.7 7.7 4.2 0 7.7-3.4 7.7-7.7C71.3 7.4 67.9 4 63.7 4z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M5.7 64.7c0.5-0.2 1-0.3 1.5-0.3v-5l-4-6.7c-0.4-0.1-0.9-0.2-1.4-0.3v-0.2H6v0.2c-0.5 0.2-1 0.3-1.5 0.3l3.6 6.1 3.9-6.2c-0.4-0.1-0.8-0.2-1.2-0.3v-0.2h3v0.2c-0.3 0.1-0.6 0.2-1 0.3l-4.3 6.8v5c0.6 0.1 1.1 0.2 1.5 0.3v0.2H5.7V64.7z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M19 63.3c-1-1.2-1.5-2.8-1.5-4.8 0-2.1 0.5-3.7 1.5-4.8 1-1.2 2.4-1.7 4.2-1.7 1.8 0 3.2 0.6 4.2 1.7 1 1.2 1.5 2.8 1.5 4.8 0 2-0.5 3.7-1.5 4.8 -1 1.2-2.4 1.7-4.2 1.7C21.4 65 20 64.4 19 63.3zM26.4 62.8c0.7-1.1 1.1-2.5 1.1-4.3 0-1.8-0.4-3.2-1.1-4.3 -0.7-1.1-1.8-1.6-3.3-1.6 -1.4 0-2.5 0.5-3.3 1.6 -0.7 1.1-1.1 2.5-1.1 4.3 0 1.8 0.4 3.3 1.1 4.3 0.7 1.1 1.8 1.6 3.3 1.6C24.6 64.4 25.7 63.9 26.4 62.8z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M35.3 63.3c-1-1.2-1.5-2.8-1.5-4.8 0-1.3 0.2-2.5 0.7-3.5 0.5-1 1.1-1.7 2-2.3 0.9-0.5 1.9-0.8 3.1-0.8 0.8 0 1.6 0.1 2.4 0.3 0.8 0.2 1.4 0.5 1.8 0.9l-0.1 2.1h-0.3c-0.1-0.3-0.2-1-0.3-1.9 -0.2-0.2-0.7-0.4-1.3-0.5 -0.6-0.2-1.2-0.2-1.7-0.2 -1.6 0-2.8 0.5-3.6 1.6 -0.8 1.1-1.2 2.5-1.2 4.3 0 1.8 0.4 3.3 1.1 4.3 0.7 1.1 1.9 1.6 3.5 1.6 0.4 0 0.8-0.1 1.3-0.2 0.5-0.1 0.9-0.3 1.3-0.4v-4.7c-0.6-0.1-1.1-0.2-1.5-0.3v-0.2h4v0.2c-0.4 0.2-0.8 0.3-1.3 0.4v4.7c-0.4 0.4-1 0.6-1.8 0.8 -0.7 0.2-1.5 0.3-2.3 0.3C37.7 65 36.3 64.4 35.3 63.3z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M61.4 64.7v0.2h-4.2v-0.2c0.4-0.2 0.9-0.3 1.5-0.3l-1-2.8h-5.7l-1 2.8c0.6 0.1 1.1 0.2 1.5 0.3v0.2h-3.7v-0.2c0.5-0.2 0.9-0.3 1.4-0.3L54.7 52h0.9L60 64.3C60.5 64.4 61 64.5 61.4 64.7zM57.5 60.9l-2.6-7.4 -2.6 7.4H57.5z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M74.4 64.7c0.5-0.2 1-0.3 1.5-0.3V52.6c-0.6-0.1-1.1-0.2-1.5-0.3v-0.2h3l7.4 11V52.6c-0.6-0.1-1.1-0.2-1.5-0.3v-0.2h3.7v0.2c-0.3 0.1-0.8 0.2-1.5 0.3v12.2h-0.8l-8.1-12v11.5c0.5 0.1 1 0.2 1.5 0.3v0.2h-3.7V64.7z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M93.5 63.3c-1-1.2-1.5-2.8-1.5-4.8 0-2.1 0.5-3.7 1.5-4.8 1-1.2 2.4-1.7 4.2-1.7 1.8 0 3.2 0.6 4.2 1.7 1 1.2 1.5 2.8 1.5 4.8 0 2-0.5 3.7-1.5 4.8 -1 1.2-2.4 1.7-4.2 1.7C95.9 65 94.5 64.4 93.5 63.3zM100.9 62.8c0.7-1.1 1.1-2.5 1.1-4.3 0-1.8-0.4-3.2-1.1-4.3 -0.7-1.1-1.8-1.6-3.3-1.6 -1.4 0-2.5 0.5-3.3 1.6 -0.7 1.1-1.1 2.5-1.1 4.3 0 1.8 0.4 3.3 1.1 4.3s1.8 1.6 3.3 1.6C99.1 64.4 100.2 63.9 100.9 62.8z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M108.7 52.6c-0.5-0.1-1-0.2-1.4-0.4v-0.2h4.2v0.2c-0.4 0.2-0.9 0.3-1.5 0.3l2.6 10.6 3.2-10.5h0.7l3.6 10.9 3-11.1c-0.4-0.1-0.7-0.2-1.1-0.3v-0.2h2.9v0.2c-0.4 0.2-0.7 0.3-1.1 0.3L120.5 65h-1.1L116 54.6 112.8 65h-0.9L108.7 52.6z"
          />
        </svg>
      </router-link>
    </div>

    <div class="navbar-brand">
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        @click="toggleMenu()"
        v-on-clickaway="closeMenu"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
  </nav>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: `NavBar`,

  data() {
    return {
      navOpen: false,
      menuClass: `navbar-menu app-nav container-is-fluid`,
    };
  },

  mixins: [clickaway],

  methods: {
    changeClasses(term) {
      if (term === false) {
        this.menuClass = `navbar-menu app-nav container-is-fluid`;
        this.navOpen = false;
      } else {
        this.menuClass = `navbar-menu app-nav container-is-fluid open`;
        this.navOpen = true;
      }
    },
    toggleMenu() {
      // eslint-disable-next-line
      this.navOpen ? this.changeClasses(false) : this.changeClasses(true);
    },

    closeMenu() {
      this.changeClasses(false);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$purple: #656b85;
$white: #ffffff;
$pinky: #fd7170;
$eggplant: #703e55;

.app-nav {
  padding: 25px 20px 25px 0;
  display: block;
  width: 250px;
  position: fixed;
  top: 104px;
  right: -300px;
  z-index: 100;
  transition: all 300ms ease;
  background-color: $white;
  a {
    display: inline-block;
    padding: 5px;
    color: $purple;
    transition: color 300ms ease;
    transition: transform 100ms ease;
    margin-left: 15px;

    &:hover {
      color: $eggplant;
      text-decoration: none;
    }
    &:focus {
      text-decoration: none;
    }
  }
  .router-link-exact-active {
    color: $eggplant;
  }
}

.app-nav.open {
  right: 0;
}

.logo {
  position: absolute;
  top: -5px;
  left: -10px;
  z-index: 110;
  transform: scale(0.7);
}

.navbar-burger {
  color: $purple;
  display: block;
}

.mobile-menu {
  display: block;
  a {
    display: inline-block;
    width: 40%;
    font-size: 12px;
    border-bottom: 1px solid lighten($purple, 30%);

    svg {
      vertical-align: text-bottom;
      zoom: 0.8;
      // margin-left: 10px;
    }
    .st1,
    .st0 {
      fill: $purple;
    }
    .st2 {
      stroke: $purple;
    }
  }

  .router-link-exact-active {
    color: $eggplant;
    .st1,
    .st0 {
      fill: $eggplant;
    }
    .st2 {
      stroke: $eggplant;
    }
  }
}

@media screen and (min-width: 1200px) {
  .app-nav {
    width: auto;
    position: static;
    top: 0;
    right: 0;
  }
  .navbar-brand {
    display: none;
  }
  .mobile-menu {
    display: none;
  }
}
</style>
